import React from 'react'
import './interest.css';
function interest() {
  return (
    <div className="interest">
     <div className='first'>
        <h1>Listening To Music</h1>
        <p>It just lowers my Stress and elevates my mood .
I listen to music whenever i feel sad, happy , stressed and while travelling . It also regain my Consciousness.
        </p>
     </div>
     <div className='first'>
        <h1>Travelling</h1>
        <p>Travelling helps me to connect with new people,which helps to improve my interpersonal skills.
            It makes me independent and build my confidence too.
        </p>
     </div>
     <div className='first'>
        <h1>Streaming Sci-Fi Movies</h1>
        <p>I just love the scifi movies ,it makes me to think beyond my imagination and these movies fascinates me 
            to learn  more about Science.
        </p>
     </div>
    </div>

  )
}

export default interest 